/* ============================================================================
   THE PRODUCT PHOTOGRAPH, OPENED AND LOOKED AT PROPERLY.

   THE OWNER'S WORDS, 25 August 2026: "и фото в продукт пейдже должны
   открываться на экране как зум / на телефоне и пк / если я нажимаю левой
   кнопкой мыши я хочу посмотреть ее детальнее." A left click on a product
   photograph means SHOW ME MORE, on a phone as well as on a desk.

   WHAT THIS FILE IS. One viewer, built by script the first time somebody asks
   for it and appended to <body> as a native <dialog>. There is NO new Liquid
   and no new markup in any template: sections/cooper-pdp-buy.liquid gains a
   single deferred <script> tag and nothing else. A buyer who never presses a
   photograph pays for one pointer listener and one 44px button, and never for
   the dialog, its stylesheet or a single extra byte of image.

   ---------------------------------------------------------------------------
   EVERY NUMBER BELOW WAS MEASURED ON /products/hawaii-bucket-hat ON 26 AUGUST
   2026 -- the bytes with curl through the storefront password, the geometry in
   a real browser at 1440x900 DPR 1 and 390x844 DPR 3. Two earlier drafts of
   this viewer were written against stale figures and both got the central
   trade wrong, so the figures are written down here rather than remembered.

   1. THE FILES ARE 1254 PIXELS, AND THERE IS NO 1024 ANYWHERE. All nine frames
      were fetched and their JPEG SOF markers decoded: eight are 1254x1254 and
      the breed guide is 1280x1020. Earlier notes in this project claimed the
      first frame was 1024x1024; that was true of the file this listing carried
      before it was re-exported, and hawaii-bucket-hat-01-product-v2.jpg is
      1254x1254 like the rest. Nothing in this file depends on the number --
      the ceiling is read from the bitmap that actually arrives -- but a
      comment that lies about the shop is worse than no comment.

   2. THERE IS NO BIGGER FILE TO ASK FOR. ?width=1400 and ?width=2048 return
      BYTE-IDENTICAL responses on all nine frames -- 245288, 311196, 241638,
      372541, 383446, 146487, 192079, 192140 and 221226 bytes, the same at both
      widths, because 1400 is already above every master and Shopify does not
      upscale. Asking for 2048 would spend a second full download under a new
      cache key for exactly zero extra pixels. This viewer therefore never
      builds an image URL: it asks for the strip's own data-pdp-thumb, which is
      that ?width=1400 URL, and it needs no change on the day the masters are
      re-exported bigger.

   3. WHAT THAT REQUEST ACTUALLY COSTS, AND THE CLAIM THIS FILE REFUSES TO
      MAKE. The gallery's lead image carries sizes="(min-width: 1024px) 46vw,
      100vw" over a 700w/1400w srcset, so which file the page already holds
      depends on the screen, and it is NOT always the big one:

        * PHONE, 390x844 DPR 3. 100vw at DPR 3 wants 1170 pixels, so the
          browser has already chosen ?width=1400. MEASURED: lead.currentSrc
          ends &width=1400. Opening this viewer there costs ZERO BYTES.
        * DESKTOP AT DPR 2. 46vw of 1440 is 662 CSS px, 1324 device px, so the
          1400 candidate is chosen again. Zero bytes.
        * DESKTOP AT DPR 1 -- an ordinary 1080p monitor at 100% scaling, and
          quite possibly the owner's. MEASURED: lead.currentSrc ends &width=700.
          The big file is NOT in the cache and opening the viewer is a real
          fetch of 146 to 383 KB. assets/cooper-pdp.js's warm Map does not help
          here either: heat() copies the lead's own sizes and srcset onto its
          preloader on purpose, so what it has warmed under the 1400 URL is the
          700 pixel file.

      That download is worth making rather than avoiding, and this is the one
      place the file spends bytes deliberately: at DPR 1 the fitted photograph
      is 868 CSS px, which is 868 device pixels, and the 700 pixel file cannot
      draw them. The viewer would otherwise open SOFTER than the frame it came
      out of. What it must never do is pretend the download is free, and it
      does not: the picture is on screen instantly on the copy the frame has
      already decoded, at exactly the size the sharp one will occupy, and the
      sharp file fades in over it when it arrives.

   4. WHAT "BIGGER" IS WORTH ON EACH SCREEN, MEASURED THROUGH THIS VIEWER.

        DESKTOP 1440x900. The in-page frame is 652.5 x 652.5 CSS px. Fitted to
        the viewport inside a 16px inset the photograph is 868 x 868 -- 1.33x
        the frame in each direction, 1.77x the area. A real and visible gain
        before anything is magnified at all.

        PHONE 390x844. The frame is 370 x 370 and the fitted photograph is
        366 x 366. MEASURED 0.989x: A LIGHTBOX ALONE MAKES THE PICTURE ONE PER
        CENT SMALLER THAN IT ALREADY WAS. This single number is why an earlier
        draft of this viewer, which offered no magnification on a phone at all,
        was the wrong answer to the request: it would have shipped the owner a
        phone "zoom" that shows his photograph slightly smaller than the page
        does. What a phone gains from the dark ground -- the page going away,
        the other eight frames one swipe apart -- is worth having, but it is
        not what he asked for, and on a phone the magnifier IS the feature.

   5. THE HONEST CEILING, AND WHY THE MAGNIFIER GOES PAST IT ANYWAY. Drawing
      one image pixel per device pixel is the point where a photograph stops
      revealing anything new. On these files that point is:

        * desktop DPR 1: the fit asks 868 device pixels of 1254, so there is
          1.44x of unseen detail left. Real headroom.
        * phone DPR 3: the fit asks 1098 device pixels of 1254 -- MEASURED
          ceiling factor 1.142x. Almost nothing held back.
        * desktop DPR 2: the fit asks 1736 of 1254 and is ALREADY upsampling.

      A magnifier that stopped at those numbers would give a phone 1.14x and a
      retina laptop nothing, which is a viewer that answers a question about
      pixels instead of the question the owner asked. So it goes to twice the
      fit even where the file has less than that to give, because angular size
      still helps an eye at arm's length read an embroidered word, and because
      every photograph viewer the buyer has ever used behaves this way. The
      rule is one line -- max = min(4, max(2, native)) -- and it is written so
      that the ceiling FOLLOWS THE FILE: re-export the photography at 2048px or
      more and `native` rises above 2 on every screen here, the cap rises with
      it, and this file needs no edit. That re-export is the only real fix for
      "детальнее", and it is worth saying to the owner in those words.

   6. NOTHING IS EVER CROPPED, AT ANY SCALE. The stage is sized in script to
      the photograph's own fitted rectangle and both images inside it are
      object-fit: contain at 100% of that box, so the whole picture is on
      screen at fit and the magnified view can only ever be panned within the
      picture's own edges -- the clamp allows exactly the overhang and not one
      pixel more. The owner reported cropped photographs as a bug once already
      and the answer was contain; a viewer that filled the screen by cutting
      the edges off would be the same bug wearing a new coat. The landscape
      breed guide is the frame to check it on: 1280x1020 fits to 1089x868 on a
      desk, a ratio of 1.255 against the file's own 1.255.

   7. TWO SIZING TRAPS THAT WERE PAID FOR IN EARLIER DRAFTS AND ARE DESIGNED
      OUT HERE RATHER THAN GUARDED AGAINST.

      FIRST: A HOLDING COPY MUST NOT SIZE ITSELF. A draft that gave the
      viewer's <img> width:auto/height:auto with max-width and max-height 100%
      opened at 700x700 on the desktop -- the intrinsic size of the holding
      copy -- and then JUMPED to 868x868 when the sharp file landed, because
      those rules clamp a large image down and never scale a small one up. The
      stage owns the size here and the images merely fill it, which is the same
      mechanism .cooper-pdp__frame img already uses in the page, so the 320px
      thumbnail, the 700px candidate and the 1254px master all paint on exactly
      the same pixels and the arrival is a sharpening rather than a jump.

      SECOND: lead.naturalWidth IS NOT THE FILE'S PIXEL COUNT. An <img> chosen
      out of a w-descriptor srcset reports its intrinsic size as the bitmap
      divided by the density the browser worked out for the candidate it
      picked. MEASURED on the live page: the lead reports naturalWidth 662 for
      a file that is 700 pixels wide. The viewer's own <img> is therefore given
      a PLAIN src with no srcset and no sizes, which makes ITS naturalWidth the
      truth -- and that number is not decoration here, it is the input to the
      magnification ceiling in point 5.

   8. THE DESIGN TOKENS ARE ON [data-cooper], NOT ON :root. MEASURED:
      --background reads "(unset)" on document.documentElement and "#f2f1ee" on
      the section, because assets/cooper-tokens.css deliberately scopes every
      token to the attribute so that Ella's own :root palette is neither beaten
      nor lost to. A dialog appended to <body> would come out UNSTYLED -- so
      this one carries data-cooper itself, exactly as sections/cooper-scratch
      .liquid's dialog does, and every var() below still names a literal
      fallback in case it is ever mounted somewhere stranger.

      IT IS APPENDED TO <body> AND NOT INTO THE SECTION, AND THAT IS THE FIX
      FOR A PROVEN DEFECT. A draft that appended the dialog inside .cooper-pdp
      was taken down with the section on shopify:section:load -- and removing
      an open modal from the document fires NO close event, so its teardown
      never ran. Anything that draft had put on the root element stayed there
      with nothing left alive to clear it. On <body> the dialog outlives a
      section re-render, and the handler at the bottom of this file closes it
      politely when one happens.

   9. THIS VIEWER TAKES NO SCROLL LOCK AT ALL, WHICH IS THE POINT. A modal
      dialog does not stop the page behind it scrolling in Chrome, and the
      usual answer -- an inline overflow on the root element -- is the same
      mechanism assets/cooper-cart.js:261 already uses for the drawer and is
      the thing that leaked in the draft described above. Containment here is
      declarative instead: touch-action on the dialog means a finger cannot
      reach the document, the dialog's own wheel handler stops a mouse, and its
      keydown stops Space, PageUp, PageDown, Home and End. Nothing is written
      to documentElement, so nothing can be left on it. MEASURED at 1440x900:
      the page's scrollbar is 15px wide and showModal() causes no reflow, so
      there is nothing to compensate for either. (A note in an earlier draft
      blamed assets/cooper-scratch.js for holding a root overflow lock. It does
      not -- grep it; the file that touches root overflow is cooper-cart.js.)

   WHAT THIS FILE DELIBERATELY DOES NOT DO, because assets/cooper-pdp.js
   already does it and doing it twice is how the two come to disagree: there is
   no second warm Map, no second preloader, no second saveData leash and no
   second swap function. Paging inside the viewer calls the matching thumbnail
   button's own click(), which runs the gallery's single show() -- so the
   frame, its --frame ratio, the alt text, aria-current and the warm Map behind
   the viewer all stay in step, kept there by the code that owns them.
   ========================================================================= */
(() => {
  'use strict';

  /* ------------------------------------------------------------------------
     THE NUMBERS THAT DECIDE WHAT A TOUCH MEANT.

     SLOP = 10 CSS px, the distance past which a press stops being a press.
     Chromium's own kTouchSlop is 8 CSS px -- the point at which it decides a
     touch is a scroll and stops emitting a click at all -- Android's
     ViewConfiguration touch slop is the same 8dp, and UIKit's pan recogniser
     needs about 10pt. 10 is the largest of the platform figures, so nothing
     any platform calls a tap is rejected here, and in practice the browser's
     own 8px rule has usually killed the click before this test is reached.

     TAPMS = 500 ms, and it applies to fingers and pens ONLY. It is Android's
     ViewConfiguration.getLongPressTimeout and roughly iOS's image-callout
     delay: past it the press is the platform's own "save this photograph"
     gesture and must not ALSO open or magnify something over the callout. A
     mouse has no such gesture, so a deliberate 900 ms left press still counts.

     SWIPE_SHUT is deliberately the longest of the three because it is the one
     that throws the buyer's place away: it must not fire on a lazy vertical
     wobble during a sideways flick.
     --------------------------------------------------------------------- */
  const SLOP = 10;
  const TAPMS = 500;
  const SWIPE_STEP = 60;
  const SWIPE_SHUT = 90;

  /* The magnified view is at least twice the fit and never more than four
     times it, with the honest one-image-pixel-per-device-pixel figure allowed
     to raise the floor whenever the file can afford it. See point 5 of the
     note above for why a viewer built only on the honest figure would be the
     wrong answer to the owner's request on the two screens he named. */
  const MAG_MIN = 2;
  const MAG_MAX = 4;

  /* The four strings this file introduces. They are English because the shop
     is, and the opener's is read off the frame first so a later commit can
     move it into the section's schema without touching this file -- a new
     schema setting forces the section to be pushed before any template that
     uses it, and this patch must not be the thing that forces that push. */
  const SAY_OPEN = 'Look closer at this photograph';
  const SAY_SHUT = 'Close';
  const SAY_PREV = 'Previous photograph';
  const SAY_NEXT = 'Next photograph';

  /* ------------------------------------------------------------------------
     THE STYLESHEET TRAVELS WITH THE SCRIPT rather than living in the section,
     and that is a decision rather than laziness. A separate cooper-zoom.css
     would need a second <link> in sections/cooper-pdp-buy.liquid, and this
     patch is allowed exactly one line in that contested file; rules kept in
     the section's own {% stylesheet %} would be paid for by every product page
     whether or not anybody ever zoomed. Injected here it lands at the end of
     <head>, after Ella's base.css and after the compiled section styles, so
     every rule below wins its ties without !important -- which matters on this
     shop, where Instafeed's sheet is on record for overriding our tiles by id.
     --------------------------------------------------------------------- */
  const SHEET = `
  /* THE GROUND IS ::backdrop AND NOTHING ELSE, for the reason already written
     into sections/cooper-scratch.liquid: the top layer paints ::backdrop below
     the dialog and above every other thing on the page, which is exactly what
     a sibling div cannot do. It is darker than that card's 0.72 because
     product photography sits on a near-white canvas and at 0.72 the page's own
     ground showed through the edge of the picture. ::backdrop cannot be relied
     on to inherit the section's tokens in every engine that ships it, so it
     names the literal.

     touch-action: none, at every scale, and this is a settled disagreement
     rather than an oversight. Two things fall out of it: a one-finger drag
     cannot reach the document, which is how the page behind stays still
     without a single preventDefault on a touch event and without any scroll
     lock; and a two-finger pinch is delivered to this file instead of to the
     browser, which is what lets a pinch magnify THE PHOTOGRAPH inside a stable
     frame rather than magnifying the browser's own visual viewport along with
     the close button. The buyer keeps a pinch either way -- it is the same
     fingers doing a better thing -- and the page outside the viewer is never
     touched, so the browser's own zoom is one Escape away. */
  dialog.cooper-zoom {
    position: fixed;
    inset: 0;
    width: 100%;
    max-width: 100%;
    height: 100%;
    max-height: 100%;
    margin: 0;
    padding: 0;
    border: 0;
    overflow: hidden;
    background-color: transparent;
    color: var(--background, #f2f1ee);
    overscroll-behavior: contain;
    touch-action: none;
    --zoom-pad: 16px;
  }

  dialog.cooper-zoom::backdrop {
    background-color: rgb(12 12 11 / 0.92);
  }

  @media (max-width: 700px) {
    dialog.cooper-zoom { --zoom-pad: 12px; }
  }

  /* THE FIELD THE PHOTOGRAPH IS FITTED INTO. inset rather than padding, so its
     clientWidth and clientHeight ARE the space the picture may have and the
     arithmetic in the script has nothing to subtract. flex with margin auto on
     the stage rather than grid place-items, because a grid's implicit auto row
     sizes to max-content and a percentage height resolved against THAT ROW is
     how an earlier draft let a photograph overflow its own stage and get
     clipped -- the owner's crop, rebuilt inside the viewer that was supposed
     to cure it. */
  .cooper-zoom__field {
    position: absolute;
    inset: var(--zoom-pad);
    display: flex;
    overflow: hidden;
    user-select: none;
    -webkit-user-select: none;
  }

  /* THE STAGE IS THE PICTURE. Its box is set in script to the photograph's own
     fitted rectangle in pixels, which is what makes the press-outside test a
     geometric question about a real edge, and what guarantees the holding copy
     and the sharp file land on identical pixels whatever their intrinsic sizes
     are. Magnification is a transform on this element, not a scroll container:
     there is nothing to scroll, so nothing can scroll the controls away. */
  .cooper-zoom__stage {
    position: relative;
    flex: 0 0 auto;
    margin: auto;
    transform-origin: 50% 50%;
    will-change: transform;
  }

  .cooper-zoom__shot {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: contain;
    object-position: center;
    display: block;
    /* -webkit-touch-callout is deliberately NOT disabled: a long press on the
       photograph should still offer iOS its own Save Image, which is the touch
       spelling of the right click this file is careful not to steal. */
  }

  /* THE HOLDING PICTURE, BORROWED RATHER THAN INVENTED -- the same idea
     assets/cooper-pdp.js uses in the frame and for the same measured reason.
     The copy the buyer just pressed is decoded on his screen this instant, so
     it goes underneath immediately and the sharp file fades in over it. */
  .cooper-zoom__shot[data-zoom-sharp] {
    opacity: 0;
    transition: opacity 160ms var(--ease-ui, cubic-bezier(.44,0,.56,1));
  }

  dialog.cooper-zoom[data-zoom-ready] .cooper-zoom__shot[data-zoom-sharp] {
    opacity: 1;
  }

  dialog.cooper-zoom[data-zoom-ready] .cooper-zoom__stage { cursor: zoom-in; }
  dialog.cooper-zoom[data-zoom-big] .cooper-zoom__stage { cursor: grab; }
  dialog.cooper-zoom[data-zoom-drag] .cooper-zoom__stage { cursor: grabbing; }

  /* EVERY CONTROL IS 44px AND EVERY ONE IS A SIBLING OF THE FIELD, NOT A CHILD
     OF THE STAGE. sections/cooper-scratch.liquid carries the receipt for the
     number: that card's 40px close button was the only visible exit from a
     modal on a 390-wide screen and was raised to 44 as the touch floor. Being
     siblings is what makes "a control that cannot be zoomed away" true rather
     than hoped for -- magnification transforms the stage, and these are not in
     it.

     WHERE THEY LAND IS NOT THE SAME ON THE TWO SCREENS, AND THE LAYOUT FOLLOWS
     THAT. The fit is height-constrained on a desk and width-constrained on a
     phone, so the empty ground is on a different axis: MEASURED, a square
     photograph leaves 270px of ground down each SIDE at 1440x900 and none
     above or below, and 227px above and below at 390x844 and 12px at the
     sides. So on a desk the paging arrows go in the side bands, where they
     never touch the picture, and on a phone they come down into the bottom
     band beside the counter -- which also puts them under the thumb instead of
     at the middle of an 844px-tall screen. Each still carries its own
     translucent pill and a blur, because the close button does sit over the
     picture's top corner on a desk and has to stay legible over a pale leopard
     print as readily as over the dark ground. */
  .cooper-zoom__btn {
    position: absolute;
    z-index: 3;
    display: grid;
    place-items: center;
    width: 44px;
    height: 44px;
    min-width: 44px;
    min-height: 44px;
    padding: 0;
    border: 0;
    border-radius: 999px;
    background-color: rgb(0 0 0 / 0.42);
    color: #fff;
    cursor: pointer;
    -webkit-backdrop-filter: blur(6px);
    backdrop-filter: blur(6px);
    transition: background-color var(--dur-ui, 200ms) var(--ease-ui, ease);
  }

  .cooper-zoom__btn:hover { background-color: rgb(0 0 0 / 0.62); }
  .cooper-zoom__btn[hidden] { display: none; }
  .cooper-zoom__btn svg { width: 20px; height: 20px; pointer-events: none; }

  .cooper-zoom__shut { top: var(--zoom-pad); right: var(--zoom-pad); }
  .cooper-zoom__prev { left: var(--zoom-pad); top: 50%; margin-top: -22px; }
  .cooper-zoom__next { right: var(--zoom-pad); top: 50%; margin-top: -22px; }

  /* THE COUNTER IS A PICTURE OF WHERE YOU ARE, NOT A CONTROL, so it takes no
     pointer events: a press that lands on it is a press on the ground behind
     it and closes the viewer, which is what somebody aiming at the ground
     expects. The sentence a screen reader is given is the visually hidden one
     below it, because that one can carry the photograph's alt text. */
  .cooper-zoom__count {
    position: absolute;
    z-index: 3;
    left: 50%;
    bottom: var(--zoom-pad);
    transform: translateX(-50%);
    margin: 0;
    padding: 0 12px;
    height: 28px;
    display: grid;
    place-items: center;
    border-radius: 999px;
    background-color: rgb(0 0 0 / 0.42);
    color: #fff;
    font-size: 13px;
    line-height: 1;
    letter-spacing: .06em;
    pointer-events: none;
    -webkit-backdrop-filter: blur(6px);
    backdrop-filter: blur(6px);
  }

  .cooper-zoom__count[hidden] { display: none; }

  /* ON A PHONE NOTHING OVERLAPS THE PHOTOGRAPH AT ALL. The fit is
     width-constrained there, so the 227px bands above and below it are the
     only empty ground -- the arrows come down to flank the counter in the
     lower one, where they are also under a thumb rather than at the middle of
     an 844px screen, and the close button stays in the upper one. 88px is the
     counter's half-width plus the button's, so the three sit in a row without
     touching. */
  @media (max-width: 700px) {
    .cooper-zoom__prev {
      left: calc(50% - 88px);
      top: auto;
      bottom: var(--zoom-pad);
      margin-top: 0;
      margin-bottom: -8px;
    }
    .cooper-zoom__next {
      right: calc(50% - 88px);
      top: auto;
      bottom: var(--zoom-pad);
      margin-top: 0;
      margin-bottom: -8px;
    }
  }

  .cooper-zoom__say {
    position: absolute;
    width: 1px;
    height: 1px;
    overflow: hidden;
    clip-path: inset(50%);
    white-space: nowrap;
  }

  /* Ella's base.css carries a blanket \`*:focus { outline: 0 }\`, so every focus
     ring in this shop is a restatement rather than a decoration. The note is
     sections/cooper-scratch.liquid's and it applies to all four buttons here. */
  .cooper-zoom__btn:focus-visible,
  .cooper-pdp__peek:focus-visible {
    outline: 2px solid var(--focus, #1b4dd1);
    outline-offset: 2px;
    opacity: 1;
  }

  /* THE DOOR FOR A KEYBOARD, AND THE ONLY VISIBLE SIGN THAT THE PHOTOGRAPH
     DOES ANYTHING AT ALL.

     MEASURED before this patch: .cooper-pdp__media contained exactly nine
     focusable elements, the nine thumbnails, and both the frame and the lead
     image reported tabIndex -1. There was no way to enlarge a photograph
     without a mouse because there was nothing to put focus on. This is a real
     <button> rather than a role on the image, so its accessible name can say
     "look closer" while the image's alt keeps saying what the picture is.

     IT DOES NOT COVER THE PHOTOGRAPH, and that is the whole reason it is a
     corner chip. Ella's own answer to this (.product-media-container__zoom-
     button, base.css:6599) is a transparent button stretched to 100% x 100%
     over the media, which takes the image out of the right click's reach and
     with it "Save image as...". With this chip instead, the centre of the
     frame still hit-tests to IMG[data-pdp-lead], and the chip occupies 44x44
     of a 652.5x652.5 frame on a desk (0.45%) and of a 370x370 one on a phone
     (1.4%), in the corner, inside the frame's own 16px radius so the frame's
     overflow rounds it.

     ON A MOUSE THE CURSOR IS ALREADY THE AFFORDANCE, so the chip waits for a
     hover; on a touch screen there is no cursor to change, so it is always
     there. A finger never fires hover, and that media query is how one rule
     gives the two devices different answers. */
  .cooper-pdp__peek {
    position: absolute;
    z-index: 2;
    inset-block-end: var(--spacing-half, 6px);
    inset-inline-end: var(--spacing-half, 6px);
    display: grid;
    place-items: center;
    width: 44px;
    height: 44px;
    min-width: 44px;
    min-height: 44px;
    padding: 0;
    border: 0;
    border-radius: 999px;
    background-color: color-mix(in oklab, var(--background, #f2f1ee) 82%, transparent);
    color: var(--foreground, #1d1c19);
    cursor: zoom-in;
  }

  .cooper-pdp__peek svg { width: 20px; height: 20px; display: block; }

  @media (hover: hover) and (pointer: fine) {
    .cooper-pdp__peek {
      opacity: 0;
      transition: opacity var(--dur-ui, 200ms) var(--ease-ui, ease);
    }
    .cooper-pdp__frame:hover .cooper-pdp__peek,
    .cooper-pdp__peek:focus-visible { opacity: 1; }
  }

  /* THE CURSOR WAITS FOR THE SCRIPT, so the page never promises a zoom it
     cannot yet perform: this file is deferred, and before it runs a press on
     the photograph does nothing at all.

     :not([data-pdp-blind]) IS LOAD-BEARING AND WAS PAID FOR. The section's own
     .cooper-pdp__frame[data-pdp-blind] { cursor: progress } says a swap is in
     flight, and it has exactly the same specificity as this rule -- but the
     section's styles are compiled into a stylesheet in <head> while this sheet
     is appended to the END of head, so on a tie THIS rule wins and the wait
     cursor was measured to disappear. Excluding the state outright is the fix
     that does not require an edit to the contested section. */
  .cooper-pdp__frame[data-zoom-ready]:not([data-pdp-blind]) {
    cursor: zoom-in;
  }

  /* LESS MOTION MEANS NO MOTION, and here that covers three things: the sharp
     file's fade over its soft copy, the chip's hover, and the stage following
     a finger during a dismissing swipe. The swipe still WORKS under this rule
     -- it simply commits or does not, with no travel to watch, which is the
     same information delivered without the movement somebody asked us not to
     make. */
  @media (prefers-reduced-motion: reduce) {
    .cooper-zoom__shot[data-zoom-sharp],
    .cooper-zoom__btn,
    .cooper-pdp__peek { transition: none; }
  }
  `;

  let styled = false;

  const dress = () => {
    if (styled) return;
    styled = true;
    const tag = document.createElement('style');
    tag.id = 'cooper-zoom-style';
    tag.textContent = SHEET;
    document.head.appendChild(tag);
  };

  /* Drawn inline rather than fetched. assets/icon-zoom.svg exists in this
     theme, but a control that only ever appears on a product page should not
     cost a request to draw, and these four glyphs are a handful of path
     commands each. */
  const ICON = {
    peek:
      '<svg viewBox="0 0 20 20" aria-hidden="true" focusable="false" fill="none"' +
      ' stroke="currentColor" stroke-width="1.6" stroke-linecap="round">' +
      '<circle cx="8.5" cy="8.5" r="5.5"/><path d="M12.7 12.7 18 18M6 8.5h5M8.5 6v5"/></svg>',
    shut:
      '<svg viewBox="0 0 20 20" aria-hidden="true" focusable="false" fill="none"' +
      ' stroke="currentColor" stroke-width="1.9" stroke-linecap="round">' +
      '<path d="M5 5l10 10M15 5L5 15"/></svg>',
    prev:
      '<svg viewBox="0 0 20 20" aria-hidden="true" focusable="false" fill="none"' +
      ' stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round">' +
      '<path d="M12.5 4l-6 6 6 6"/></svg>',
    next:
      '<svg viewBox="0 0 20 20" aria-hidden="true" focusable="false" fill="none"' +
      ' stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round">' +
      '<path d="M7.5 4l6 6-6 6"/></svg>',
  };

  const still = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  const calm = () => !!(still && still.matches);

  /* The intrinsic size of every photograph is READ, never loaded. Liquid
     already prints it on each thumbnail as data-pdp-thumb-ratio="W / H" -- the
     real preview_image dimensions, which is how the gallery reshapes the frame
     before any bytes arrive -- so the fit can be computed in the same task as
     the press, with no image to wait for. It is only ever the OPENING
     estimate: once the sharp file has decoded, the magnification ceiling is
     recomputed from that bitmap's own naturalWidth, so a preview_image that
     disagreed with what the CDN actually returned could not mislead the
     magnifier into presenting an upsample as detail. */
  const dims = (text, fw, fh) => {
    const bits = String(text || '').split('/');
    const w = parseInt(bits[0], 10);
    const h = parseInt(bits[1], 10);
    if (w > 0 && h > 0) return {w, h};
    const bw = parseInt(fw, 10);
    const bh = parseInt(fh, 10);
    if (bw > 0 && bh > 0) return {w: bw, h: bh};
    return {w: 1, h: 1};
  };

  /* ------------------------------------------------------------------------
     ONE VIEWER FOR THE PAGE, BUILT ON THE FIRST PRESS.

     Not one per section and not one per photograph: only one picture is ever
     being looked at, and a single instance is also the only way the focus
     bookkeeping below stays honest.
     --------------------------------------------------------------------- */
  let room = null;

  /* ------------------------------------------------------------------------
     THE FIT, THE CEILING AND THE PAINT.

     The third term in the fit -- the 1 -- is the anti-upscale cap, and it is
     what keeps the BASE view honest: a 1254 pixel photograph is never
     stretched past 1254 CSS px by the fit itself, so what the buyer first sees
     is always the sharpest the file can be. On the two screens measured it
     does not bind (0.692 on a desk, 0.292 on a phone); it only comes into play
     in a window taller than about 1286px, where the picture would otherwise be
     blown up before he has asked for anything. Asking for more is what the
     magnifier is for, and that is a deliberate act rather than a default.
     --------------------------------------------------------------------- */
  const fitScale = (shot) => {
    const w = room.field.clientWidth;
    const h = room.field.clientHeight;
    if (!shot || w <= 0 || h <= 0) return 1;
    return Math.min(w / shot.w, h / shot.h, 1);
  };

  /* THE CEILING FOLLOWS THE FILE. `native` is the factor at which the stage
     would draw exactly one image pixel per device pixel, read from the bitmap
     that actually arrived rather than from anything Liquid printed. On today's
     masters it is 1.44 on a DPR 1 desk and 1.14 on a DPR 3 phone, so the floor
     of 2 governs everywhere -- but re-export the photography at 2048px and
     `native` climbs past 2 on every screen here and the cap climbs with it,
     with no edit to this file. */
  const maxScale = () => {
    const nat = room.ready ? room.sharp.naturalWidth : 0;
    const base = room.stage.offsetWidth;
    if (!nat || !base) return MAG_MIN;
    const native = nat / (base * (window.devicePixelRatio || 1));
    return Math.min(MAG_MAX, Math.max(MAG_MIN, native));
  };

  /* The centre of the stage's UNTRANSFORMED box, which is the field's centre
     because the stage is margin: auto inside it. Everything the magnifier does
     is expressed as an offset from this point, so it has to be read from the
     field rather than from the stage's own (already transformed) rectangle. */
  const centre = () => {
    const r = room.field.getBoundingClientRect();
    return {x: r.left + r.width / 2, y: r.top + r.height / 2};
  };

  /* THE CLAMP IS THE NO-CROP GUARANTEE IN ARITHMETIC. On an axis where the
     magnified photograph is larger than the field it may travel by exactly
     half the difference in each direction -- which puts its own edge against
     the field's edge and no further -- and on an axis where it is smaller it
     stays centred. A pan can therefore never expose ground beside the picture,
     and can never push part of the picture permanently out of reach. */
  const clampPan = () => {
    const w = room.stage.offsetWidth * room.scale;
    const h = room.stage.offsetHeight * room.scale;
    const spanX = Math.max(0, (w - room.field.clientWidth) / 2);
    const spanY = Math.max(0, (h - room.field.clientHeight) / 2);
    room.tx = Math.min(spanX, Math.max(-spanX, room.tx));
    room.ty = Math.min(spanY, Math.max(-spanY, room.ty));
  };

  const paint = () => {
    clampPan();
    room.stage.style.transform =
      'translate(' + room.tx + 'px,' + room.ty + 'px) scale(' + room.scale + ')';
    if (room.scale > 1.001) room.dialog.setAttribute('data-zoom-big', '');
    else room.dialog.removeAttribute('data-zoom-big');
  };

  /* Sizing the stage to the fitted rectangle is what makes every image inside
     it -- a 320px thumbnail, a 700px candidate, a 1254px master -- paint on
     identical pixels. An earlier draft let the images size themselves and the
     viewer opened at the holding copy's intrinsic size and then jumped when
     the sharp file landed; see point 7 of the note at the top. */
  const layout = () => {
    const shot = room.shots[room.at];
    if (!shot) return;
    const s = fitScale(shot);
    room.stage.style.width = Math.round(shot.w * s) + 'px';
    room.stage.style.height = Math.round(shot.h * s) + 'px';
    const cap = maxScale();
    if (room.scale > cap) room.scale = cap;
    paint();
  };

  /* Magnification is always about a POINT, never about the middle. A buyer who
     presses the embroidered band at the bottom of a cap is asking to see THAT,
     and a magnifier that jumps to the top of the picture and makes him drag it
     back has answered a different question -- which is exactly what an earlier
     draft did, measured: a press 97.7% of the way down the photograph left the
     pressed detail off screen. */
  const zoomAbout = (px, py, want) => {
    const from = room.scale;
    const to = Math.min(maxScale(), Math.max(1, want));
    if (Math.abs(to - from) < 0.001) return;
    const c = centre();
    room.tx = px - c.x - (to / from) * (px - c.x - room.tx);
    room.ty = py - c.y - (to / from) * (py - c.y - room.ty);
    room.scale = to;
    if (to <= 1.001) {
      room.scale = 1;
      room.tx = 0;
      room.ty = 0;
    }
    paint();
  };

  const toFit = () => {
    room.scale = 1;
    room.tx = 0;
    room.ty = 0;
    paint();
  };

  /* ------------------------------------------------------------------------
     WHAT IS ON SCREEN WHILE THE SHARP FILE ARRIVES.

     THE HOLDING COPY IS NEVER A DIFFERENT PHOTOGRAPH, and that rule is worth
     stating because an earlier draft broke it: falling back to the lead's
     currentSrc whenever the pressed thumbnail had no decoded bitmap put a
     square hat inside a landscape stage, under the breed guide's label and
     counter. assets/cooper-pdp.js refuses the same fallback for the same
     reason -- when it has no bitmap to borrow it raises [data-pdp-blind] and
     shows a veil rather than the wrong picture. Here the equivalent is simply
     nothing: the stage stays empty over the dark ground for the fraction of a
     second the file takes, which says "loading" honestly and cannot mislead.
     --------------------------------------------------------------------- */
  const holding = (i) => {
    const shot = room.shots[i];
    if (!shot) return '';
    const g = room.gallery;
    const lead = g.lead;
    const settled =
      !g.frame.hasAttribute('data-pdp-hold') && !g.frame.hasAttribute('data-pdp-blind');
    if (settled && lead.getAttribute('src') === shot.url && lead.currentSrc) {
      /* The best copy available, and on a desk it is a 652px picture rather
         than a 320px one. On a phone it is already the same ?width=1400 file
         the viewer is about to ask for, out of the same cache entry, so that
         opening is not a wait at all. */
      return lead.currentSrc;
    }
    const own = shot.btn ? shot.btn.querySelector('img') : null;
    if (own && own.complete && own.naturalWidth > 0) return own.currentSrc || own.src;
    return '';
  };

  /* decode() answers "can this be painted now", and on an image that is still
     loading it also covers the wait for the bytes. A rejection is not worth
     reporting: it means the request failed, so whatever is already on screen
     stays there, which beats an empty box. */
  const painted = (img) => {
    if (img.decode) return img.decode().then(() => img, () => img);
    return new Promise((done) => {
      if (img.complete) {
        done(img);
        return;
      }
      img.addEventListener('load', () => done(img), {once: true});
      img.addEventListener('error', () => done(img), {once: true});
    });
  };

  const goTo = (i, tellPage) => {
    const n = room.shots.length;
    room.at = ((i % n) + n) % n;
    const shot = room.shots[room.at];

    /* Every move takes a ticket, for the reason assets/cooper-pdp.js documents
       in its own swap: image requests do not settle in the order they were
       started, so a buyer flicking through four frames must not be left
       looking at the second. Only the newest move may touch the visible
       elements. */
    const mine = ++room.ticket;

    room.ready = false;
    room.dialog.removeAttribute('data-zoom-ready');
    toFit();

    const soft = holding(room.at);
    if (soft) room.soft.src = soft;
    else room.soft.removeAttribute('src');
    room.sharp.alt = shot.alt;
    layout();

    room.count.hidden = n < 2;
    room.count.textContent = room.at + 1 + ' / ' + n;
    room.prevBtn.hidden = n < 2;
    room.nextBtn.hidden = n < 2;
    /* The counter is hidden from the reading order; this is the sentence a
       screen reader is actually given, and it carries the photograph's own alt
       text because that is the part that says what changed. */
    room.say.textContent = room.at + 1 + ' of ' + n + '. ' + shot.alt;

    /* A THROWAWAY Image() DOES THE WAITING, and it is given a plain src with
       no srcset and no sizes: this is the one request that has to be for a
       known file rather than for whatever a candidate list would resolve to,
       and it is the same URL the strip carries, so on a phone and on a retina
       desk it lands in a cache entry the page has already filled. */
    const probe = new Image();
    probe.decoding = 'async';
    probe.src = shot.url;
    painted(probe).then(() => {
      if (mine !== room.ticket) return;
      room.sharp.removeAttribute('srcset');
      room.sharp.removeAttribute('sizes');
      room.sharp.src = shot.url;
      const reveal = () => {
        if (mine !== room.ticket) return;
        room.ready = true;
        room.dialog.setAttribute('data-zoom-ready', '');
        layout();
      };
      /* One more beat before the reveal, for the same reason the gallery
         waits: assigning src starts the update-the-image-data steps, it does
         not repaint, so revealing in the same task would show the PREVIOUS
         bitmap for one frame -- a blink back to the picture just left. The
         bytes are in cache by here, so it costs a frame. */
      if (room.sharp.decode) room.sharp.decode().then(reveal, reveal);
      else reveal();
    });

    /* THE PAGE UNDERNEATH IS KEPT IN STEP BY THE CODE THAT OWNS IT. Pressing
       the matching thumbnail runs assets/cooper-pdp.js's own show(), the single
       swap function for this gallery: it moves the frame, the frame's ratio,
       the alt text, aria-current and its warm Map together. Duplicating any of
       that here is how the frame and the viewer would come to disagree about
       which photograph the buyer is looking at. A programmatic click does not
       move focus, so the focus trap this dialog gets from the browser is not
       disturbed by it. */
    if (tellPage && shot.btn) shot.btn.click();
  };

  const step = (by) => {
    if (room.shots.length < 2) return;
    goTo(room.at + by, true);
  };

  /* ------------------------------------------------------------------------
     THE GESTURES INSIDE THE VIEWER.

     One rule holds at every scale, which is what makes it learnable: A PRESS
     ON THE PHOTOGRAPH MEANS CLOSER, A PRESS ON THE GROUND BESIDE IT MEANS
     DONE, and a press on the photograph while it is already magnified goes
     back to the fit. That last clause is not symmetry for its own sake -- an
     earlier draft returned early from pointerup whenever the view was
     magnified, so a click could not return to the fit and the buyer was
     stranded at 2x with only the close button as a way out.

     At the fit a sideways drag pages and a downward drag dismisses; while
     magnified the same movements are a pan, because there the buyer is looking
     around one picture rather than moving between nine.

     Two fingers pinch at every scale. That is a settled disagreement: with
     touch-action left at pinch-zoom the browser would zoom its own visual
     viewport, taking the close button and the counter with it and requiring
     two fingers to pan afterwards, and the meaning of a pinch would change the
     moment our own magnifier engaged. One consistent gesture that zooms the
     PICTURE, capped at what the file can honestly show, is the better trade;
     the browser's own pinch is untouched everywhere outside this dialog.
     --------------------------------------------------------------------- */
  const wireDialogGestures = () => {
    const pts = new Map();
    let solo = null;
    let pinch = null;

    const onPicture = (x, y) => {
      const r = room.stage.getBoundingClientRect();
      return x >= r.left && x <= r.right && y >= r.top && y <= r.bottom;
    };

    const isControl = (t) =>
      !!(t && t.closest && t.closest('button, a, [role="button"], input, label'));

    const clearPreview = () => {
      room.dialog.removeAttribute('data-zoom-drag');
      room.dialog.style.opacity = '';
      paint();
    };

    const drop = (e) => {
      pts.delete(e.pointerId);
      if (pts.size < 2) pinch = null;
    };

    room.dialog.addEventListener('pointerdown', (e) => {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      if (isControl(e.target)) return;
      pts.set(e.pointerId, {x: e.clientX, y: e.clientY});

      if (pts.size === 1) {
        solo = {
          id: e.pointerId,
          x0: e.clientX,
          y0: e.clientY,
          tx0: room.tx,
          ty0: room.ty,
          t0: performance.now(),
          kind: e.pointerType,
          moved: 0,
          spoiled: false,
        };
        if (room.scale > 1) room.dialog.setAttribute('data-zoom-drag', '');
        return;
      }

      /* A second finger means a pinch, and it retires the pending press: a
         gesture that was two fingers can never also have been a tap. */
      if (solo) solo.spoiled = true;
      room.dialog.removeAttribute('data-zoom-drag');
      room.dialog.style.opacity = '';
      if (pts.size === 2 && room.ready) {
        const two = [...pts.values()];
        pinch = {
          d0: Math.hypot(two[0].x - two[1].x, two[0].y - two[1].y) || 1,
          s0: room.scale,
        };
      }
    });

    room.dialog.addEventListener('pointermove', (e) => {
      if (!pts.has(e.pointerId)) return;
      pts.set(e.pointerId, {x: e.clientX, y: e.clientY});

      if (pinch && pts.size >= 2) {
        const two = [...pts.values()];
        const d = Math.hypot(two[0].x - two[1].x, two[0].y - two[1].y) || 1;
        zoomAbout((two[0].x + two[1].x) / 2, (two[0].y + two[1].y) / 2, pinch.s0 * (d / pinch.d0));
        return;
      }

      if (!solo || e.pointerId !== solo.id) return;
      const dx = e.clientX - solo.x0;
      const dy = e.clientY - solo.y0;
      solo.moved = Math.max(solo.moved, Math.abs(dx), Math.abs(dy));

      if (room.scale > 1) {
        room.tx = solo.tx0 + dx;
        room.ty = solo.ty0 + dy;
        paint();
        return;
      }

      /* At the fit the stage follows the finger downwards only, only while the
         gesture is clearly vertical, and only when motion is allowed. The
         ground thins with it so the page underneath begins to show through,
         which is what tells the buyer this drag is a way out rather than a
         scroll he is failing to perform. */
      if (!calm() && dy > 0 && Math.abs(dy) > Math.abs(dx) * 1.5) {
        room.stage.style.transform = 'translate(0px,' + Math.round(dy) + 'px) scale(1)';
        room.dialog.style.opacity = String(Math.max(0.35, 1 - dy / 480));
      } else if (room.dialog.style.opacity) {
        /* The finger came back up, or turned sideways into a paging swipe. The
           preview has to be undone as it is withdrawn rather than only at
           pointerup, or the photograph sits stuck at the lowest point the
           finger reached while the finger is somewhere else entirely. */
        room.dialog.style.opacity = '';
        paint();
      }
    });

    room.dialog.addEventListener('pointerup', (e) => {
      const mine = solo && e.pointerId === solo.id ? solo : null;
      const wasPinch = !!pinch;
      drop(e);
      if (!mine) return;
      solo = null;
      clearPreview();
      if (mine.spoiled || wasPinch) return;
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      if (isControl(e.target)) return;

      const dx = e.clientX - mine.x0;
      const dy = e.clientY - mine.y0;

      /* THE SWIPES BELONG TO THE FIT STATE ONLY. While magnified the same
         movements were a pan and have already been spent. */
      if (room.scale === 1) {
        if (dy > SWIPE_SHUT && Math.abs(dy) > Math.abs(dx) * 1.5) {
          room.dialog.close();
          return;
        }
        if (Math.abs(dx) > SWIPE_STEP && Math.abs(dx) > Math.abs(dy) * 1.5) {
          step(dx < 0 ? 1 : -1);
          return;
        }
      }

      if (mine.moved > SLOP) return;
      /* A press held past the platform's long-press timeout is the platform's
         own save gesture, not a request to magnify -- and a mouse has no such
         gesture, so a deliberate slow click still counts. */
      if (mine.kind !== 'mouse' && performance.now() - mine.t0 > TAPMS) return;

      /* THE PRESS-OUTSIDE TEST IS GEOMETRIC, against the picture's own
         rectangle, rather than a test on the event target. The ground and the
         dialog are the same element as far as a target is concerned, so a
         target test would also close the viewer when somebody pressed the
         empty band beside the picture -- which is exactly where the controls
         live and where a buyer's thumb rests. */
      if (!onPicture(e.clientX, e.clientY)) {
        room.dialog.close();
        return;
      }
      if (room.scale > 1) {
        toFit();
        return;
      }
      /* NEVER MAGNIFY THE HOLDING COPY. Until the sharp file has decoded, the
         picture on screen is a 320px thumbnail or a 700px candidate, and
         blowing either up to twice the fit would present a 1.8x upsample as
         detail -- precisely the thing this viewer refuses to do. */
      if (!room.ready) return;
      zoomAbout(e.clientX, e.clientY, maxScale());
    });

    room.dialog.addEventListener('pointercancel', (e) => {
      drop(e);
      solo = null;
      clearPreview();
    });

    /* THE WHEEL, AND THE ORDER OF ITS TWO LINES IS THE WHOLE POINT. ctrl+wheel
       is how a browser delivers its own page zoom AND how macOS and Windows
       deliver a trackpad pinch, so it is handed straight back -- an earlier
       draft cancelled the default BEFORE testing ctrlKey and killed both
       inside the one view whose entire purpose is looking closer. A plain
       wheel is ours: there is nothing in this dialog to scroll, and a wheel
       that scrolled the page behind the photograph would be a bug. A passive
       listener may not call preventDefault, so this one cannot be passive. */
    room.dialog.addEventListener(
      'wheel',
      (e) => {
        if (e.ctrlKey) return;
        e.preventDefault();
        if (!room.ready) return;
        zoomAbout(e.clientX, e.clientY, room.scale * (e.deltaY < 0 ? 1.18 : 1 / 1.18));
      },
      {passive: false},
    );
  };

  /* ------------------------------------------------------------------------
     THE KEYBOARD.

     THE FIRST TEST IS THE ONE AN EARLIER DRAFT DID NOT HAVE, and its absence
     was a real WCAG 2.1.1 failure: that draft prevented the default on Enter
     and Space unconditionally, so with focus on the 44px Close button neither
     key activated it -- the visible way out swallowed both of its own
     activation keys. Anything focusable keeps its own keys here, and the
     viewer's shortcuts apply only while the dialog itself has focus.

     Escape closes, and this handler only calls stopPropagation for it, never
     preventDefault -- preventing it would keep the dialog OPEN. It is here
     because assets/cooper-pdp.js's wirePickers puts an Escape handler on the
     DOCUMENT that closes every open .cooper-pdp__picker, and a modal's Escape
     must dismiss the modal and nothing behind it.

     Space, PageUp, PageDown, Home and End are prevented because with focus on
     a dialog that has nothing to scroll the browser scrolls the DOCUMENT
     behind the photograph. There is no CSS spelling of that the way
     touch-action covers a finger.

     ArrowLeft and ArrowRight page here and CANNOT collide with the strip's own
     handlers: assets/cooper-pdp.js binds those on the thumbnail BUTTONS, and
     while this dialog is modal focus cannot be on one. The same holds for the
     pending patch that adds visible arrows to the frame -- those are controls
     in the page, behind a modal, and this file adds no listener to the
     document or the window at all except the resize one at the bottom.
     --------------------------------------------------------------------- */
  const wireKeys = () => {
    room.dialog.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        e.stopPropagation();
        return;
      }
      if (e.target !== room.dialog) return;

      const c = centre();

      if (e.key.indexOf('Arrow') === 0) {
        e.preventDefault();
        if (room.scale > 1) {
          const d = 64;
          if (e.key === 'ArrowLeft') room.tx += d;
          if (e.key === 'ArrowRight') room.tx -= d;
          if (e.key === 'ArrowUp') room.ty += d;
          if (e.key === 'ArrowDown') room.ty -= d;
          paint();
        } else if (e.key === 'ArrowRight') {
          step(1);
        } else if (e.key === 'ArrowLeft') {
          step(-1);
        }
        return;
      }
      if (e.key === ' ' || e.key === 'Spacebar' || e.key === 'Enter') {
        e.preventDefault();
        if (!room.ready) return;
        zoomAbout(c.x, c.y, room.scale > 1 ? 1 : maxScale());
        return;
      }
      if (e.key === '+' || e.key === '=') {
        e.preventDefault();
        if (room.ready) zoomAbout(c.x, c.y, room.scale * 1.25);
        return;
      }
      if (e.key === '-' || e.key === '_') {
        e.preventDefault();
        zoomAbout(c.x, c.y, room.scale / 1.25);
        return;
      }
      if (e.key === '0') {
        e.preventDefault();
        toFit();
        return;
      }
      if (e.key === 'PageUp' || e.key === 'PageDown' || e.key === 'Home' || e.key === 'End') {
        e.preventDefault();
      }
    });
  };

  /* ------------------------------------------------------------------------
     CLOSING. Escape, the close button, a press on the ground, a downward
     swipe and a section re-render all funnel through the dialog's own close
     event, so there is exactly one teardown however the buyer left.
     --------------------------------------------------------------------- */
  const teardown = () => {
    room.dialog.removeAttribute('data-zoom-ready');
    room.dialog.removeAttribute('data-zoom-big');
    room.dialog.removeAttribute('data-zoom-drag');
    room.dialog.style.opacity = '';
    room.ready = false;
    room.ticket += 1;
    toFit();

    /* WHERE FOCUS GOES BACK TO, AND THE TWO TESTS THAT ARE NOT DECORATION.

       If the buyer paged to another photograph, focus goes to THAT frame's
       thumbnail: it is where his attention now is, it makes the strip agree
       with the frame he is looking at, and ArrowLeft/ArrowRight already work
       from there. Otherwise it goes back where it came from.

       document.activeElement IS <body> AFTER A MOUSE OR A FINGER OPENED THE
       VIEWER -- an <img> is not focusable, so pressing the photograph moves
       focus nowhere. <body> passes an isConnected check and body.focus() on an
       element with no tabindex does nothing at all, so without the first test
       a keyboard user's next Tab would start from the top of the document.
       And focus can be left on the CLOSED dialog, which is display:none but is
       still reported as activeElement in Chrome; without the second test the
       next open would record that as "where I came from" and hand focus to a
       hidden element for good. Both were caught in testing, not in theory. The
       chip on the frame is the fallback, which is where the buyer is looking.
       preventScroll for the reason written in cooper-pdp.js's wireBait: the
       browser's scroll-into-view on focus jumps the page. */
    let going = null;
    const g = room.gallery;
    if (g && room.at !== room.from && room.shots[room.at] && room.shots[room.at].btn) {
      going = room.shots[room.at].btn;
    } else {
      const back = room.back;
      const usable =
        back &&
        back.isConnected &&
        back !== document.body &&
        back !== document.documentElement &&
        !room.dialog.contains(back);
      going = usable ? back : room.home;
    }
    if (going && going.isConnected) going.focus({preventScroll: true});
    room.back = null;
  };

  const build = () => {
    dress();

    const dialog = document.createElement('dialog');
    dialog.className = 'cooper-zoom';
    /* Without data-cooper none of the tokens in the sheet above resolve -- see
       point 8 of the note at the top of this file. */
    dialog.setAttribute('data-cooper', '');
    /* Focus lands on the dialog itself on open so a screen reader is told
       where it is and then reads the photograph's own alt, rather than being
       handed the way out first. */
    dialog.tabIndex = -1;

    const field = document.createElement('div');
    field.className = 'cooper-zoom__field';

    const stage = document.createElement('div');
    stage.className = 'cooper-zoom__stage';

    const soft = document.createElement('img');
    soft.className = 'cooper-zoom__shot';
    soft.alt = '';
    soft.setAttribute('aria-hidden', 'true');
    soft.draggable = false;

    const sharp = document.createElement('img');
    sharp.className = 'cooper-zoom__shot';
    sharp.setAttribute('data-zoom-sharp', '');
    sharp.decoding = 'async';
    sharp.alt = '';
    /* draggable off, and only inside the viewer. A mouse drag on an <img>
       starts a native drag-and-drop, which here would fight panning; on the
       page's own lead image that same drag is a legitimate way to pull the
       photograph out to the desktop, and this file does not touch it. */
    sharp.draggable = false;

    stage.appendChild(soft);
    stage.appendChild(sharp);
    field.appendChild(stage);

    const mkBtn = (cls, label, glyph) => {
      const b = document.createElement('button');
      b.type = 'button';
      b.className = 'cooper-zoom__btn ' + cls;
      b.setAttribute('aria-label', label);
      b.innerHTML = glyph;
      return b;
    };

    const shutBtn = mkBtn('cooper-zoom__shut', SAY_SHUT, ICON.shut);
    const prevBtn = mkBtn('cooper-zoom__prev', SAY_PREV, ICON.prev);
    const nextBtn = mkBtn('cooper-zoom__next', SAY_NEXT, ICON.next);

    const count = document.createElement('p');
    count.className = 'cooper-zoom__count';
    count.setAttribute('aria-hidden', 'true');

    const say = document.createElement('p');
    say.className = 'cooper-zoom__say';
    say.setAttribute('role', 'status');
    say.setAttribute('aria-live', 'polite');

    dialog.appendChild(field);
    dialog.appendChild(shutBtn);
    dialog.appendChild(prevBtn);
    dialog.appendChild(nextBtn);
    dialog.appendChild(count);
    dialog.appendChild(say);
    document.body.appendChild(dialog);

    room = {
      dialog: dialog,
      field: field,
      stage: stage,
      soft: soft,
      sharp: sharp,
      prevBtn: prevBtn,
      nextBtn: nextBtn,
      count: count,
      say: say,
      gallery: null,
      shots: [],
      at: 0,
      from: 0,
      scale: 1,
      tx: 0,
      ty: 0,
      ticket: 0,
      ready: false,
      back: null,
      home: null,
    };

    shutBtn.addEventListener('click', () => dialog.close());
    prevBtn.addEventListener('click', () => step(-1));
    nextBtn.addEventListener('click', () => step(1));

    wireDialogGestures();
    wireKeys();

    dialog.addEventListener('close', teardown);

    return room;
  };

  /* ------------------------------------------------------------------------
     OPENING. Idempotent on purpose: a mouse produces a pointerup AND a click,
     and the second of anything must land inside the open viewer rather than
     reopen it.
     --------------------------------------------------------------------- */
  const open = (gallery, i) => {
    if (!room) build();
    if (room.dialog.open) return;
    if (!gallery.shots.length || !gallery.shots[0].url) return;

    room.gallery = gallery;
    room.shots = gallery.shots;
    room.home = gallery.chip;
    room.back = document.activeElement;
    room.from = i;

    /* Named from the product's own <h1>, so there is no new schema setting to
       push before this can ship and nothing to keep in sync with the title. */
    room.dialog.setAttribute(
      'aria-label',
      gallery.title ? gallery.title + ', photographs' : 'Photographs',
    );

    room.dialog.showModal();
    room.dialog.focus({preventScroll: true});
    /* The fit needs the field's real clientWidth, which only exists once the
       dialog is being displayed, so the first layout happens after showModal
       and never before. */
    goTo(i, false);
  };

  /* Which photograph the frame is showing. aria-current is the gallery's own
     answer and assets/cooper-pdp.js moves it in the same frame as the click --
     before any bytes land -- so a viewer opened mid-swap opens the picture the
     buyer just asked for rather than the one still on screen. */
  const currentIndex = (gallery) => {
    for (let i = 0; i < gallery.shots.length; i += 1) {
      const b = gallery.shots[i].btn;
      if (b && b.getAttribute('aria-current') === 'true') return i;
    }
    /* No strip, or a strip that has not been wired: the frame is showing the
       lead, which is the first entry in the list. */
    return 0;
  };

  /* ------------------------------------------------------------------------
     THE WAY IN. Three of them, and each is deliberately narrow.

     A LEFT PRESS ON THE PHOTOGRAPH, which is literally what was asked for. The
     decision is taken on pointerup rather than on click, and that is not
     pedantry: a swipe patch is being added to this same frame tonight, and if
     it calls preventDefault on touchstart -- which is how a homemade swipe
     usually stops the page scrolling -- the browser emits NO click on a phone
     at all and the zoom would be dead on the device the owner asked about
     first. pointerup is delivered either way.

     Nothing is ever preventDefault'ed on the frame, which is why the right
     click still reaches the context menu and its "Save image as...", why a
     long press still raises iOS's callout, and why the swipe patch can cancel
     whatever it likes without this file having to be consulted.

     A CLICK WITH detail 0, which is what a screen reader's activation gesture
     or a switch device sends. A real mouse click always reports 1 or more, so
     it cannot double-fire -- and open() is idempotent anyway.

     AND THE 44px CHIP, because a press is not a way in for everybody. The
     frame is a div and cannot be made a button -- it is about to contain
     buttons, and nested interactive content is invalid -- so the chip is the
     keyboard's door, the screen reader's door, and the only visible sign the
     photograph does anything.

     A THUMBNAIL NEVER OPENS THE VIEWER, and structurally it cannot:
     ul.cooper-pdp__thumbs is the frame's SIBLING inside .cooper-pdp__media --
     verified in the live markup -- so a frame-scoped listener cannot see a
     thumbnail press. That is also the right meaning: a strip whose buttons
     sometimes change the frame and sometimes throw a modal over it makes
     paging feel like a trap.
     --------------------------------------------------------------------- */
  const wireFrame = (gallery) => {
    const frame = gallery.frame;
    let down = null;

    frame.addEventListener(
      'pointerdown',
      (e) => {
        /* A second finger means a pinch on the page, not a tap. isPrimary is
           the test rather than a counter because the browser already tracks
           which pointer leads a multi-touch gesture. */
        if (!e.isPrimary || e.button !== 0) {
          down = null;
          return;
        }
        down = {
          x: e.clientX,
          y: e.clientY,
          t: performance.now(),
          id: e.pointerId,
          kind: e.pointerType,
        };
      },
      {passive: true},
    );

    /* A drag lifted off, a gesture the browser took for its own scrolling, or
       a native image drag starting: all three arrive as pointercancel, and all
       three mean this was not a tap. */
    const forget = () => {
      down = null;
    };
    frame.addEventListener('pointercancel', forget, {passive: true});
    frame.addEventListener('pointerleave', forget, {passive: true});
    /* The context menu is NOT prevented, only noted, so the press that raised
       it cannot also open the viewer behind it. */
    frame.addEventListener('contextmenu', forget);

    frame.addEventListener(
      'pointerup',
      (e) => {
        const from = down;
        down = null;
        if (!from || e.pointerId !== from.id) return;

        /* LEFT BUTTON ONLY. A middle click must stay a middle click and a
           right click must reach the context menu; both arrive with a button
           that is not 0. The modifier test is assets/cooper-cart.js:1065's,
           which guards its own click the same way, with altKey added because
           Alt-click is a save gesture in some browsers. */
        if (e.button !== 0) return;
        if (e.ctrlKey || e.metaKey || e.shiftKey || e.altKey) return;

        /* The chip is a button inside this frame, and the paging arrows the
           other patch set is adding will be buttons in here too. Anything that
           is its own control keeps its own meaning. */
        if (e.target.closest && e.target.closest('button, a, [role="button"], input, label')) {
          return;
        }

        if (Math.hypot(e.clientX - from.x, e.clientY - from.y) > SLOP) return;
        if (from.kind !== 'mouse' && performance.now() - from.t > TAPMS) return;

        open(gallery, currentIndex(gallery));
      },
      {passive: true},
    );

    frame.addEventListener('click', (e) => {
      if (e.detail !== 0) return;
      if (e.target.closest && e.target.closest('button, a, [role="button"]')) return;
      open(gallery, currentIndex(gallery));
    });
  };

  /* ------------------------------------------------------------------------
     WIRING ONE GALLERY.
     --------------------------------------------------------------------- */
  const wireZoom = (box) => {
    const lead = box.querySelector('[data-pdp-lead]');
    /* A listing with no photograph renders .cooper-pdp__no-photo and no <img>.
       There is nothing to enlarge, so there is no chip and no cursor promising
       one. */
    if (!lead) return;

    /* THE FRAME IS FOUND FROM THE LEAD, NOT BY SEARCHING THE SECTION. This
       section can render a SECOND .cooper-pdp__frame -- the placeholder
       preview branch at cooper-pdp-buy.liquid:162, gated on the
       preview_when_empty setting -- inside the same .cooper-pdp root, and that
       one carries no [data-pdp-lead]. A querySelector on the box would find
       the preview frame first and wire the chip and the whole gesture to the
       wrong element. Not reachable on the served page today, which is exactly
       why it is worth closing now rather than after somebody flips a setting. */
    const frame = lead.closest('.cooper-pdp__frame');
    if (!frame || frame.hasAttribute('data-zoom-ready')) return;

    /* A browser with no <dialog> would get a chip that promises something the
       page cannot deliver, so nothing is wired at all and a press on the
       photograph keeps meaning exactly what it means today: nothing. */
    if (
      typeof HTMLDialogElement === 'undefined' ||
      typeof HTMLDialogElement.prototype.showModal !== 'function'
    ) {
      return;
    }

    dress();

    /* THE STRIP MAY NOT EXIST AT ALL. Liquid wraps it in
       {% if p.media.size > 1 %}, so a one-photograph product renders no
       thumbnails -- and assets/cooper-pdp.js returns early in that case, which
       means those pages have no gallery wiring whatsoever. The viewer must
       still open, so the list falls back to the lead alone, taking its
       intrinsic size from the width and height attributes Liquid prints on it
       and its file from the src, which is the same ?width=1400 URL the strip
       would have carried. Without this the shop's single-photograph listings
       would be the only ones a buyer could not look at properly. */
    const strip = box.querySelector('[data-pdp-thumbs]');
    const thumbs = strip ? [].slice.call(strip.querySelectorAll('[data-pdp-thumb]')) : [];
    let shots;
    if (thumbs.length) {
      shots = thumbs.map((btn) => {
        const d = dims(btn.dataset.pdpThumbRatio);
        return {
          btn: btn,
          url: btn.dataset.pdpThumb,
          alt: btn.dataset.pdpThumbAlt || '',
          w: d.w,
          h: d.h,
        };
      });
    } else {
      const d = dims('', lead.getAttribute('width'), lead.getAttribute('height'));
      shots = [
        {
          btn: null,
          url: lead.getAttribute('src') || '',
          alt: lead.getAttribute('alt') || '',
          w: d.w,
          h: d.h,
        },
      ];
    }
    if (!shots.length || !shots[0].url) return;

    const titleNode = box.querySelector('.cooper-pdp__title');

    const chip = document.createElement('button');
    chip.type = 'button';
    chip.className = 'cooper-pdp__peek';
    chip.setAttribute('data-zoom-open', '');
    chip.setAttribute('aria-label', frame.dataset.zoomLabel || SAY_OPEN);
    chip.innerHTML = ICON.peek;

    const gallery = {
      box: box,
      frame: frame,
      lead: lead,
      shots: shots,
      chip: chip,
      title: titleNode ? (titleNode.textContent || '').trim() : '',
    };

    chip.addEventListener('click', (e) => {
      /* The chip's own click must not also be read as a press on the frame.
         The pointerup path already ignores anything inside a button; this
         stops the click reaching document handlers that have no use for it. */
      e.stopPropagation();
      open(gallery, currentIndex(gallery));
    });

    /* type="button" and outside every form -- the media column closes at
       cooper-pdp-buy.liquid:1090 and {% form 'product' %} only opens at :1208,
       so this cannot be read as a submit even if the attribute were ever lost.
       Verified live: the frame's closest('form') is null. */
    frame.appendChild(chip);

    wireFrame(gallery);
    frame.setAttribute('data-zoom-ready', '');
  };

  /* ------------------------------------------------------------------------
     BOOT, AND THE TWO THINGS THAT KEEP THE VIEWER HONEST ABOUT ITS
     SURROUNDINGS.

     A turned phone or a dragged window changes the fit and can take the
     magnifier's headroom with it -- turning this phone to landscape changes
     the fit by more than double -- so the stage is re-measured and the pan
     re-clamped, and layout() drops the scale back if the ceiling has fallen
     below it. Only while the viewer is actually open: there is nothing to lay
     out otherwise, and this is a listener on the window in a shop whose home
     page has already had to give a megabyte back.

     And a section re-render in the owner's own theme editor must not leave an
     open viewer over a page whose frame, thumbnails and chip have all been
     replaced underneath it. Closing it runs the one teardown, and the buyer
     lands back on a freshly wired gallery.
     --------------------------------------------------------------------- */
  const bind = (root) => {
    const scope = root instanceof Element ? root : document;
    const boxes = scope.querySelectorAll('.cooper-pdp');
    for (let i = 0; i < boxes.length; i += 1) wireZoom(boxes[i]);
  };

  window.addEventListener('resize', () => {
    if (room && room.dialog.open) layout();
  });

  bind(document);
  document.addEventListener('shopify:section:load', (event) => {
    if (room && room.dialog.open) room.dialog.close();
    bind(event.target);
  });
})();
